<template>
  <div class="avatar" :data-recipe="recipe" style="float: left">
    <div class="avatar--body" ></div>
    <div class="avatar--eye" ></div>
    <div class="avatar--eyeAccessory" ></div>
    <div class="avatar--mouth" ></div>
    <div class="avatar--hat" ></div>
    <div class="avatar--nose" ></div>
    <div class="avatar--neck" ></div>
  </div>
</template>

<script>
  export default {
    props: ['recipe']
  }
</script>

<style scoped lang="scss">

$parts:
  "body" ("blue" "fluffy" "green" "pink" "red" "yellow") 0px 0px,
  "eyeAccessory" ("clown" "eyebrow" "mask" "minion" "monocle" "pirate" "star" "glass") 0px 50px,
  "eye" ("fear" "fun" "furious" "suspicious" "think" "want") 45px 65px,
  "hat" ("classy" "devilHorns" "feathers" "chef" "music" "snowCap" "unicornHorn" "santa" "magician" "bunny" "explorer" "king" "caregiver" "sharpBlue" "sharpYellow") 0px 0px,
  "mouth" ("bigSmile" "full" "poker" "reverse" "smile" "surprise") 38px 110px,
  "neck" ("autumn" "balloon" "beard" "blueScarf" "blueTie" "books" "redScarf" "redTie" "skyTie" "easter" "fiole" "santaBeard" "heartJewelry" "cake" "gift" "blueballoon" "sceptre" "sign" "constructionSign" "tubes" "syringe" "constructionSign") 0px 50px,
  "nose" ("bigMustache" "dandyMustache" "clown" "upMustache" "mask" "pig" "bone") 0px 70px;

.avatar {
  top: 20px;
  left: 75px;

  width: 150px;
  height: 200px;
  position: relative;
}

[class^="avatar--"] {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-repeat: no-repeat;
}

@each $partType, $partList, $xOffset, $yOffset in $parts {
  [class="avatar--#{$partType}"] {
    background-position: $xOffset $yOffset;
  }
  @each $part in $partList {
    [data-recipe~="#{ $partType }-#{ $part }"] .avatar--#{$partType} {
    background-image: url('~@/assets/images/avatar/parts/#{ $partType }-#{ $part }.png')
    }
  }
}

</style>
